import SellingPoints from './SellingPoints';

export default SellingPoints;
